<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/rebate',title:'信贷管理'},{title:'财务退税凭证'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox zhi">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="网单号">
							    <el-input v-model="formInline.zwbdr" placeholder=""></el-input>
							</el-form-item>
							<el-form-item label="分销凭证号">
								<el-input v-model="formInline.vbeln" ></el-input>
							</el-form-item>
							<el-form-item label="会计凭证编号">
								<el-input v-model="formInline.belnr" placeholder=""></el-input>
							</el-form-item>
                            <el-form-item label="开票凭证">
                                <el-input v-model="formInline.billNo" placeholder=""></el-input>
                            </el-form-item>
						</div>

						<el-collapse-transition>
						<div v-show="isScreen">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="客户名称">
								<el-input v-model="formInline.soldToName" placeholder=""></el-input>
							</el-form-item>
							<el-form-item label="客户编码">
								<el-input v-model="formInline.soldToCode" ></el-input>
							</el-form-item>
							<el-form-item  label="订单类型">
								<brselect
										style="width:100%"
										clearable
										category="cr_type"
										:v="formInline.orderCategory"
										v-model="formInline.orderCategory"
										placeholder="--请选择--">
								</brselect>
							</el-form-item>
							<el-form-item  label="订单子类型">
								<brselect
										style="width:100%"
										clearable
										category="xiaoshou_quyu_nwx"
										:v="formInline.orderCategory1"
										v-model="formInline.orderCategory1"
										placeholder="--请选择--">
								</brselect>
							</el-form-item>
						</div>
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="过账日期" style="width: 50%;">
								<el-date-picker
										placeholder="请选择"
										v-model="formInline.budat"
										clearable
										type="date"
										value-format="yyyy-MM-dd" >
								</el-date-picker>
								<span class="w-time-to">至</span>
								<el-date-picker
										placeholder="请选择"
										v-model="formInline.budatI"
										clearable
										type="date"
										value-format="yyyy-MM-dd" >
								</el-date-picker>
							</el-form-item>
							<el-form-item label="提单号">
								<el-input v-model="formInline.billCode" placeholder=""></el-input>
							</el-form-item>
							<el-form-item label="报关单号">
								<el-input v-model="formInline.customsCode" placeholder=""></el-input>
							</el-form-item>

						</div>

								<div class="h-thirdColumn w-newColumn">
										<el-form-item label="　　公司代码">
											<el-input v-model="formInline.bukrs" placeholder=""></el-input>
										</el-form-item>

									<el-form-item label="箱单号">
										<el-input v-model="formInline.sapCode" placeholder=""></el-input>
									</el-form-item>
								</div>
							</div>
						</el-collapse-transition>
                    </el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="selectData">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resectData">重置
							</el-button>
						</div>
					</div>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <div style="background:#fff;width:100%;">
                        <el-table
                                ref="multipleTable"
                                @selection-change="handleSelectionChange"
                                :data="tableData2"
                                stripe
								border
                                style="width: 100%"
								max-height="460"
                        >
                            <el-table-column
                                    type="index"
                                    width="40"
                                    label="#"
                                    fixed>
                            </el-table-column>
                            <el-table-column
                                    prop="zwbdr"
                                    label="网单号"
									 :show-overflow-tooltip="true"
                                    fixed
                                    width="120">
                            </el-table-column>
							<el-table-column
									prop="soldToCode"
									label="客户编码"
									:show-overflow-tooltip="true"
									fixed
									width="120">
							</el-table-column>
							<el-table-column
									prop="soldToName"
									label="客户名称"
									:show-overflow-tooltip="true"
									fixed
									width="250">
							</el-table-column>
							<el-table-column
									prop="bukrs"
									label="公司代码"
									:show-overflow-tooltip="true"
									fixed
									width="90">
							</el-table-column>
							<el-table-column
									prop="orderCategory"
									label="订单类型"
									:show-overflow-tooltip="true"
									fixed
									width="90">
								<template slot-scope="scope" >
									<dictname category="cr_type" :v="scope.row.orderCategory" />
								</template>
							</el-table-column>
							<el-table-column
									prop="orderCategory1"
									label="订单子类型"
									width="130">
								<template slot-scope="scope" >
									<dictname category="xiaoshou_quyu_nwx" :v="scope.row.orderCategory1" />
								</template>
							</el-table-column>
							<el-table-column
									prop="ddje"
									label="含税总额"
									width="110">
							</el-table-column>
							<!--<el-table-column-->
									<!--prop="totalprice"-->
									<!--label="人民币金额"-->
									<!--width="110">-->
							<!--</el-table-column>-->
							<el-table-column
									prop="wrbtr"
									label="原币金额"
									width="150">
							</el-table-column>
							<el-table-column
									prop="vbeln"
									label="分销凭证号"
									:show-overflow-tooltip="true"
									width="120">
							</el-table-column>
							<el-table-column
									prop="auart"
									label="销售凭证类型"
									width="130">
							</el-table-column>
                            <el-table-column
                                    prop="billNo"
                                    label="开票凭证"
									:show-overflow-tooltip="true"
                                    width="120">
                            </el-table-column>
							<el-table-column
							        prop="belnr"
							        label="会计凭证编号"
									:show-overflow-tooltip="true"
							        width="120">
							</el-table-column>

							<el-table-column
									prop="customsCode"
									label="报关单号"
									:show-overflow-tooltip="true"
									width="150">
							</el-table-column>
							<el-table-column
									prop="billCode"
									label="提单号"
									:show-overflow-tooltip="true"
									width="140">
							</el-table-column>
							<el-table-column
									prop="sapCode"
									label="箱单号"
									:show-overflow-tooltip="true"
									width="130">
							</el-table-column>
							<el-table-column
							        prop="budat"
							        label="过帐日期"
							        min-width="180">
							</el-table-column>
							<el-table-column
							        prop="gjahr"
							        label="会计年度"
							        width="110">
							</el-table-column>
							<el-table-column
							        prop="bktxt"
							        label="纸质发票号"
									:show-overflow-tooltip="true"
							        width="180">
							</el-table-column>
							<!--<el-table-column-->
							        <!--prop="bldat"-->
							        <!--label="凭证日期"-->
							        <!--width="110">-->
							<!--</el-table-column>-->
							<!--<el-table-column-->
							        <!--prop="waers1"-->
							        <!--label="货币码"-->
							        <!--width="120">-->
							<!--</el-table-column>-->
							<el-table-column
							        prop="waers2"
							        label="货币码"
							        width="120">
							</el-table-column>
							<el-table-column
							        prop="kursf"
							        label="汇率"
							        width="100">
							</el-table-column>

							<el-table-column
									label="操作"
									width="100"
									fixed="right"
							>
								<template slot-scope="scope">
									<div>
										<el-button
												size="small" class="h-tableLink h-btn"
												@click="seeFile(scope.row)">查看附件
										</el-button>
									</div>
								</template>
							</el-table-column>

                        </el-table>
                    </div>
					<el-dialog
							:visible.sync="showFujianD"
							v-if="showFujianD"
							class="h-dialog2"
					>
						<div class="h-dialogImg">
							<div class="h-disTable">
								<div class="h-tableCell">
									<h1>外销订单凭证总览</h1>
								</div>
							</div>
						</div>
						<div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
							<h3 style="display: inline-block;">订单号:</h3>
							<h4 style="display: inline-block;margin-left: 0.1rem;">{{ddhU}}</h4>
						</div>
						<div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
							<h3 style="display: inline-block;">报关单</h3>
							<brupload
									style="margin-top: 0.1rem;"
									:refid="refid"
									reftype="WXFJ_BGD"
									:showtime="false"
							/>
						</div>
						<div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
							<h3 style="display: inline-block;">入货通知</h3>
							<brupload
									style="margin-top: 0.1rem;"
									:refid="refid"
									reftype="WXFJ_RHTZ"
									:showtime="false"
							/>
						</div>
						<div class="h-formLine" style="padding:20px;">
							<h3 style="display: inline-block;">提单</h3>
							<brupload
									style="margin-top: 0.1rem;"
									:refid="refid"
									reftype="WXFJ_TD"
									:showtime="false"
									/>
						</div>
					</el-dialog>

                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
								<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="downloadExcel">批量导出</el-button>
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="q" @query="selectDataPage"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import customerLedgerService from "../../../api/loud/credit/customerLedgerService";
    import util from "../../../utils/util";
    import updownfile from "../../../utils/updownfile";

    export default {
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
				
				moreCondition: false,
                userInfoCreditVo:{
                    multipleSelection: [],
                },
				showFujianD:false,
				value1:'',
                value2: '',
                value3: 36,
                names: '',
                input1: '',
                sele: '工程',
                formInline: {
                    zwbdr:null,
                    vbeln:null,
                    auart:null,
                    billNo:null,
                    belnr:null,
                    orderCategory:null,
                    budatI:null,
                    soldToName:null,
                    orderCategory1:null,
                    billCode:null,
                    customsCode:null,
                    bukrs:null,
                    budat:null,
                    gjahr:null,
                    bktxt:null,
                    bldat:null,
                    waers1:null,
                    waers2:null,
                	sapCode:null,
					soldToCode:null,
                    add2: null,
					city1:null,
					land1:null,
                    belnr:null,
                    kursf:null,
                    wrbtr:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0
                },
                q:{
                    pageSize: 10,
                    pageNo: 1,
                    total: 0
                },
                multipleSelection: [],
                tableData2: [],
            }
        },
        created() {

        },
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
			downloadExcel(){
				//ids
				var cc = [];
				for (var d in this.tableData2.id) {
					cc.push(this.tableData2[d].id);
				}
				//查询参数
				var c = {
					ids: cc,
				};
				console.log("c====",c);
				console.log(this.formInline,'!!!!!!!!!!')
				updownfile.down("/api/swyl/v1/demo/viewOrderMoneyTuishui/downloadExcel", this.formInline, 'post');
				console.log("执行完了")
			},
            timeSelect() {
                this.formInline.sptgTime = this.value2[0];
                this.formInline.sptgTime1 = this.value2[1];
            },
			timeSelect1() {
				this.formInline.add5 = this.value1[0];
				this.formInline.add5I = this.value1[1];
			},
            //检索按钮功能
            selectData() {
                this.q.pageNo = 1;
                this.selectDataPage();
            },
            selectDataPage() {
                this.q.zwbdr = this.formInline.zwbdr?this.formInline.zwbdr:null;
                this.q.vbeln = this.formInline.vbeln?this.formInline.vbeln:null;
                this.q.auart = this.formInline.auart?this.formInline.auart:null;
                this.q.billNo=this.formInline.billNo?this.formInline.billNo:null;
				this.q.belnr=this.formInline.belnr?this.formInline.belnr:null;
				this.q.bukrs=this.formInline.bukrs?this.formInline.bukrs:null;

                this.q.sapCode = this.formInline.sapCode?this.formInline.sapCode:null;
                this.q.customsCode = this.formInline.customsCode?this.formInline.customsCode:null;
                this.q.billCode = this.formInline.billCode?this.formInline.billCode:null;
                this.q.budatI=this.formInline.budatI?this.formInline.budatI:null;
                this.q.budat=this.formInline.budat?this.formInline.budat:null;
                this.q.orderCategory1=this.formInline.orderCategory1?this.formInline.orderCategory1:null;
                this.q.orderCategory=this.formInline.orderCategory?this.formInline.orderCategory:null;
                this.q.soldToName=this.formInline.soldToName?this.formInline.soldToName:null;
                this.q.soldToCode=this.formInline.soldToCode?this.formInline.soldToCode:null;
                customerLedgerService.querytuishuiList(this.q).then(response => {
                    console.log(response, '检索结果1')
                     this.tableData2 = response.records;
                    this.q.total = response.total;
                })
            },
			chooseModify() {
				if (this.moreCondition) {
					this.moreCondition = false;
				} else {
					this.moreCondition = true;
				}
			},
            //重置按钮功能
            resectData() {
                this.formInline.zwbdr = null;
                this.formInline.vbeln = null;
                this.formInline.auart = null;
				this.formInline.billNo = null;
				this.formInline.belnr=null;
				this.formInline.bukrs=null;

                this.formInline.soldToCode = null;
                this.formInline.soldToName = null;
                this.formInline.orderCategory = null;
                this.formInline.orderCategory1 = null;
                this.formInline.budat=null;
                this.formInline.budatI=null;
                this.formInline.billCode = null;
                this.formInline.customsCode = null;
                this.formInline.sapCode = null;
            },
            handleSelectionChange(val) {
                console.log(val,'val')
                this.multipleSelection = val;
            },
            handleSizeChange() {
                console.log(1)
            },
			seeFile(o){
				this.refid = this.ddhU = o.sapCode;
				this.showFujianD = true;
			},
            timeSelect1() {
                this.formInline.budat = this.value1[0];
                this.formInline.budatI = this.value1[1];
            },
            handleCurrentChange() {
                console.log(2)
            },
            handleScroll(e) {
                console.log(e.target.scrollLeft)
            }
        },
        mounted() {
            //查询所有信贷列表
            this.selectDataPage();
        }
    }
</script>
<style scoped>

    /* .selectorBox{
        width: 100%;
        padding: 0.54rem 0.28rem 0 0.25rem;
    }
    .selectorBox .text{
        margin-left: 0.38rem;
        font-size: 0.18rem;
        color: #4a4a4a;
        position: relative;
    }
    .selectorBox .text::before{
        content: "*";
        position: absolute;
        top: 0;
        left: -7px;
        color: red;
        font-size: 0.2rem;
    }
    .selectorBox .selector{
        margin-left: 0.38rem;
        margin-top: 20px;
        display: flex;
    }
    .selectorBox .selector .button{
        width: 65px;
        padding: 10px;
        color: #b7b7b7;
        border: 1px solid #dcdfe1;
        text-align: center;
        line-height: 20px;
        cursor: pointer;
    }
    .selectorBox .selector .button.active{
        color: #fff;
        background: #238cfd;
        border: 1px solid #238cfd;
    }
    .tip{
        margin-left: 1.6rem;
        color: #b0b0b0;
        font-size: 0.2rem;
        margin-top:10px;
    }
    .h-bgccc{
        background: #edf5fa;
        border-color: #959595;
        color: #92999e;
    } */
</style>
<style>
    /* .selectorBox .el-input-group__append{
        background: #238cfd;
        color: #fff
    }
    .selectorBox .el-upload-list{
        display: none;
    } */
    /* .h-rowIn .el-table .el-table__body-wrapper::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    } */

    /* .drags .el-slider__button-wrapper .el-slider__button{
        background: url(../../../assets/images/drag.png) center/cover;
        border: 0;
        border-radius: 0;
        width: 20px;
        height: 20px;
    } */
    .zhi .h-formBorder .el-form-item__label {
        vertical-align: top;
    }

    .zhi .el-date-editor .el-range-separator {
        width: 9%;
        margin-bottom: 0;
    }
</style>
